import { useLocation, Navigate, Outlet } from "react-router-dom";
import React, { useState, useEffect } from "react";
import axios from "axios";
import { BASE_URL } from "../config/axios";
import Loader from "../components/Loader";
import { SUSShreak } from "../components/AllSvg";

import usePermission from "../config/permissions";
import { useUser } from "./Usercontext";
import { roleAllowed } from "../config/roles";

const Auth = ({ allowedRoles }) => {
  const [role, setRole] = useState(() => sessionStorage.getItem("role"));
  const [loading, setLoading] = useState(true);

  const id = sessionStorage.getItem("customer_id");
  let token = sessionStorage.getItem("access_token");
  const location = useLocation();

  const fetchUserProfile = async () => {
    try {
      if (!token) {
        setRole(null);
        setLoading(false);
        return;
      }

      const cached = sessionStorage.getItem("role");
      if (cached) {
        setRole(cached);
        setLoading(false);
      }

      const response = await axios.get(
        `${BASE_URL}/user/userviewbyemail/${id}/`,
        {
          headers: { Authorization: `Bearer ${token}` },
        },
      );

      setRole(response.data.role);
      if (response.data.role) sessionStorage.setItem("role", response.data.role);
      // Clear the stale session so /login doesn't redirect the user straight back.
      if (!roleAllowed(response.data.role, allowedRoles)) sessionStorage.clear();
    } catch (error) {
      if (!sessionStorage.getItem("role")) {
        setRole(null);
        sessionStorage.clear();
      }
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    fetchUserProfile();
  }, []);

  if (loading) {
    return <Loader />;
  }

  return roleAllowed(role, allowedRoles) ? (
    <Outlet />
  ) : (
    <Navigate to="/login" state={{ from: location }} replace />
  );
};

export default Auth;
